import { CheckIcon, InfoCircledIcon } from "@radix-ui/react-icons";
import { Button, Callout, Flex } from "@radix-ui/themes";

type NotificationProps = {
    id: string;
    message: string;
    isViewed: boolean;
    onMarkAsRead: (id: string) => void;
  };
export const AlertNotification: React.FC<NotificationProps> = ({ id, message, isViewed, onMarkAsRead }) => {
    return (
      <Callout.Root color={isViewed ? "gray" : undefined} variant="surface">
        <Callout.Icon>
          <InfoCircledIcon />
        </Callout.Icon>
        <Flex direction="column" gap="2" align="start">
          <Callout.Text>{message}</Callout.Text>
          {!isViewed && (
            <Button
              type="button"
              size="1"
              variant="soft"
              color="green"
              onClick={() => onMarkAsRead(id)}
            >
              <CheckIcon /> Marcar como lida
            </Button>
          )}
        </Flex>
      </Callout.Root>
    );
  };